<template>
    <section class="section-footer pb-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-12 mb-4">
                    <div class="widget-a pe-4">
                        <div class="w-header-a logofoot">
                            <router-link :to="{ name: 'HomePage'}">
                                <img :src="companyLogo" class="img-fluid" :alt="companyname" style=" max-height: 40px; max-width:300px;">
                            </router-link>
                        </div>
                        <div class="w-body-a mt-4">
                            <p class="w-text-a ">
                                {{FooterLogoDescription}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
                    <div class="w-header-a">
                        <h3 class="w-title-a text-brand mb-3">{{$t('StoreFront.Links')}}</h3>
                    </div>
                    <div class="w-body-a ms-3">
                        <ul class="list-unstyled footer-link-items">
                            <li class="item-list-a link-items" v-for="link in footerNavLinks">

                                <router-link class="nav-link" :to="{ name: link.routeUrl,params:link.params}">{{link.displayText}}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6" style="display:none;">
                    <div class="w-header-a">
                        <h3 class="w-title-a text-brand"> &nbsp; </h3>
                    </div>
                    <div class="w-body-a">
                        <ul class="list-unstyled">
                            <li class="item-list-a" v-for="serviceLink in serviceLinks">
                                <router-link :to="{ name: serviceLink.routeUrl}">{{serviceLink.displayText}}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="widget-a contactinfo">
                        <div class="w-header-a">
                            <h3 class="w-title-a text-brand">{{$t('StoreFront.ContactUs')}}</h3>
                        </div>
                        <div class="w-body-a">
                            <ul class="list-unstyled">
                                <li class="item-list-a" style="line-height: 22px; color: #fff;">
                                    <i class="houzez-icon icon-pin mr-1"></i> {{OurAddress}}
                                </li>
                                <li class="item-list-a mt-3">
                                    <a :href="'tel:'+ OurPhone"><i class="houzez-icon icon-phone mr-1"></i>  {{OurPhone}}</a>
                                </li>
                            </ul>
                            <SocialMediaIconComponent></SocialMediaIconComponent>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <footer>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="copyright-footer">
                        <p class="copyright text-white" style="font-size: 14px;" v-html="Copyrights"></p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
    import SocialMediaIconComponent from '@/views/SocialMediaIcons/socialMediaIcons.vue'
    export default {
        name: 'FooterVue',
        props: ["footerNavLinks", "serviceLinks", "FooterLogoDescription", "OurAddress", "OurEmail", "OurPhone", "Copyrights"],
        components: {
            SocialMediaIconComponent
        },
        data() {
            return {
                companyLogo: '',
                companyname: localStorage.getItem('companyName'),
            }
        },
        created() {
            this.getCompanyLogo();
        },
        methods: {
            getCompanyLogo() {
                let logoUrl = localStorage.getItem('companyLogo');
                this.companyLogo = (this.$filters.IsNull(logoUrl, 'null') == 'null') ? require('../../../../../assets/images/logo/default-logo.png') : logoUrl;
            }
        }

    }
</script>

<style scoped>

    .footer-link-items {
        column-count: 2;
        column-gap: 15px;
    }

        .footer-link-items .link-items {
            font-size: 14px;
            padding: 8px 0;
            margin: 0;
        }

    @media (max-width:767px) {
        .footer-link-items {
            column-count: 1;
        }
    }
</style>